import React from "react";
import {ReactComponent as FbLogo} from '../assets/svg/Fb-Icon.svg';
import {ReactComponent as LILogo} from '../assets/svg/LI-Icon.svg';
import {ReactComponent as IGLogo} from '../assets/svg/IG-Icon.svg';
import { ReactComponent as BrandLogo} from 'assets/img/love-little-dragons-logo.svg';

export default function Footer ({modal}) {
  return (
    <>
      <footer style={{ backgroundColor: '#C10F1C'}}>
        <div className="md:p-10 p-5">
          <BrandLogo className="w-32 h-32 mx-auto my-3"/>
          <div className="md:text-2xl text-lg text-center text-[#FFFFFF] font-mm">Love The Little Dragon</div>
          <div className="md:text-xl text-lg text-center text-[#FFFFFF] avenir-book">191 Canal Street, Suite 603, New York, NY 10013</div>
          <div className="md:text-xl text-lg text-center text-[#FFFFFF] avenir-book">+1 212 203 5842</div>
          <div className="md:text-xl text-lg text-center text-[#FFFFFF] avenir-book">leong@klystar.com</div>
          <div className="flex gap-2 justify-center items-center my-5" id="socials">
            <div className="s-item flex justify-center items-center bg-[#FFBF45] w-[2.7rem] h-[2.7rem] rounded-full cursor-pointer">
              <FbLogo style={{ width: '20', height: '25'}}/>
            </div>
            <div className="s-item flex justify-center items-center bg-[#FFBF45] w-[2.7rem] h-[2.7rem] rounded-full cursor-pointer">
              <LILogo style={{ width: '20', height: '25'}}/>
            </div>
            <div className="s-item flex justify-center items-center bg-[#FFBF45] w-[2.7rem] h-[2.7rem] rounded-full cursor-pointer">
              <IGLogo style={{ width: '20', height: '25'}}/>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
} 